module.exports = __webpack_public_path__ + "img/score_04.4cdcf4f9.svg";